import { buildProps } from '@xzx-design/utils'
import { ON_RELEASE_FOCUS_EVT, ON_TRAP_FOCUS_EVT } from './tokens'

import type { ExtractPropTypes, PropType } from 'vue-demi' // test vue-demi
import type FocusTrap from './focus-trap.vue'

export const focusTrapProps = buildProps({
  loop: Boolean,
  trapped: Boolean,
  focusTrapEl: {
    type: Object as PropType<HTMLElement>,
  },
  focusStartEl: {
    type: [Object, String] as PropType<'container' | 'first' | HTMLElement>,
    default: 'first',
  },
})

export const focusTrapEmits = [
  ON_TRAP_FOCUS_EVT,
  ON_RELEASE_FOCUS_EVT,
  'focusin',
  'focusout',
  'focusout-prevented',
  'release-requested',
]

export type FocusTrapProps = ExtractPropTypes<typeof focusTrapProps>
export type FocusTrapInstance = InstanceType<typeof FocusTrap>
